import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Paper, useMediaQuery, useTheme } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import AuthService from "../../../AuthService";
import BarraTitulo from "../../Generico/BarraTitulo";
import DialogCupomDesconto from "./components/DialogCupomDesconto";
import HeaderCupomDesconto from "./components/HeaderCupomDesconto";
import TableCupomDesconto from "./components/TableCupomDesconto";

const CupomDesconto = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [cdInput, setCdInput] = useState({
    cupom: "",
    tipo: "",
    valor: 0.0,
    inicio: null,
    termino: null,
    pedidoValorMinimo: 0.0,
    ignorarProdutosPromocao: true,
    ativo: true,
    tipoCupom: "DELIVERY",
  });
  const [cupomList, setCupomList] = useState([]);
  const [cupomValido, setCupomValido] = useState(true);
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const novoCupomDesconto = () => {
    setCdInput({
      cupom: "",
      tipo: "PERCENTUAL_DA_CONTA",
      valor: 0.0,
      inicio: new Date(),
      termino: new Date(),
      pedidoValorMinimo: 0.0,
      ignorarProdutosPromocao: true,
      ativo: true,
      tipoCupom: "DELIVERY",
    });
  };

  useEffect(() => {
    const service = new AuthService();
    service
      .get(`/cupomDesconto/cupomValido?valido=${cupomValido}`)
      .then(setCupomList)
      .catch((err) => {
        enqueueSnackbar("Erro ao listar os cupons de desconto.", {
          variant: "error",
        });
        console.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cupomValido]);

  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    const newValue =
      type === "checkbox"
        ? checked
        : typeof value === "string"
        ? value.toUpperCase()
        : value; // aqui está o pulo do gato

    setCdInput((prev) => {
      const updated = { ...prev, [name]: newValue };

      if (name === "tipo") {
        if (value === "ENTREGA_GRATIS") {
          updated.valor = 0;
          updated.ignorarProdutosPromocao = false;
        } else if (value === "VALOR_FIXO") {
          updated.ignorarProdutosPromocao = false;
        }
      }

      return updated;
    });
  };

  const handleSaveAll = () => {
    const service = new AuthService();
    service
      .post("/cupomDesconto", cdInput)
      .then((resp) => {
        const updatedList = [
          ...cupomList.filter((t) => t.id !== cdInput.id),
          resp,
        ].sort((a, b) => a.id - b.id);
        setCupomList(updatedList);
        setOpen(false);
        enqueueSnackbar("Cupom criado com sucesso.", { variant: "success" });
      })
      .catch(console.error);
  };

  const validaCupom = () => {
    let salvar = true;

    if (!cdInput.inicio) {
      enqueueSnackbar("Informe a data de inicio.", { variant: "error" });
      salvar = false;
    }

    if (!cdInput.termino) {
      enqueueSnackbar("Informe a data de termino.", { variant: "error" });
      salvar = false;
    }

    if (/\W/.test(cdInput.cupom)) {
      enqueueSnackbar(
        "Não é permitido caracteres especiais e espaços no cupom.",
        { variant: "error" }
      );
      salvar = false;
    }

    if (cdInput.tipo === "PERCENTUAL_DA_CONTA" && cdInput.valor > 100) {
      enqueueSnackbar("Desconto maior que 100% não é permitido.", {
        variant: "error",
      });
      salvar = false;
    }

    if (!cdInput.cupom) {
      enqueueSnackbar("Não é permitido criar cupom de desconto sem nome.", {
        variant: "error",
      });
      salvar = false;
    }

    if (
      cupomList.some((cd) => cd.cupom === cdInput.cupom && cd.id !== cdInput.id)
    ) {
      enqueueSnackbar("Cupom de desconto já cadastrado.", { variant: "error" });
      salvar = false;
    }

    if (salvar) handleSaveAll();
  };

  const handleClickOpenNew = () => {
    novoCupomDesconto();
    setOpen(true);
  };

  const handleClickOpenEdit = (cupom) => {
    setCdInput(JSON.parse(JSON.stringify(cupom)));
    setOpen(true);
  };

  const handleDelete = (cupom, index) => {
    const service = new AuthService();
    service
      .delete(`/cupomDesconto/${cupom.id}`)
      .then(() => {
        const newList = cupomList
          .filter((_, i) => i !== index)
          .sort((a, b) => a.id - b.id);
        setPage(0);
        setCupomList(newList);
        enqueueSnackbar("Cupom excluído com sucesso", { variant: "success" });
      })
      .catch(() => {
        enqueueSnackbar("Não foi possível excluir o cupom desconto.", {
          variant: "error",
        });
      });
  };

  const buscarCupomValido = () => {
    const service = new AuthService();
    service
      .get(`/cupomDesconto/cupomValido?valido=${!cupomValido}`)
      .then(setCupomList)
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Falha ao buscar os cupons válidos.", {
          variant: "error",
        });
      });

    setCupomValido((prev) => !prev);
  };

  const onCopy = () => {
    enqueueSnackbar("Cupom copiado.", { variant: "success" });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const cupomDescontoTipoList =
    cdInput.tipoCupom === "LOCAL"
      ? [
          { label: "PERCENTUAL DA CONTA", value: "PERCENTUAL_DA_CONTA" },
          { label: "VALOR FIXO", value: "VALOR_FIXO" },
        ]
      : [
          { label: "PERCENTUAL DA CONTA", value: "PERCENTUAL_DA_CONTA" },
          { label: "ENTREGA GRÁTIS", value: "ENTREGA_GRATIS" },
          { label: "VALOR FIXO", value: "VALOR_FIXO" },
        ];

  return (
    <>
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="Cupom de desconto"
            subTitle="Cadastre os cupons de desconto"
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "10rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            size="medium"
            onClick={handleClickOpenNew}
          >
            Novo cupom
          </Button>
        </Box>
      </Box>

      <Paper>
        <HeaderCupomDesconto
          cupomValido={cupomValido}
          handleClickOpenNew={handleClickOpenNew}
          buscarCupomValido={buscarCupomValido}
        />
        <TableCupomDesconto
          cupomList={cupomList}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          onCopy={onCopy}
          handleClickOpenEdit={handleClickOpenEdit}
          handleDelete={handleDelete}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <DialogCupomDesconto
        open={open}
        cdInput={cdInput}
        cupomDescontoTipoList={cupomDescontoTipoList}
        handleClose={() => setOpen(false)}
        handleChange={handleChange}
        validaCupom={validaCupom}
      />
    </>
  );
};

export default CupomDesconto;
